import { MyIntegrationsPage } from "@/components/integrations/my-integrations-page.tsx";
import { mcpServersQueryOptions } from "@/services/mcp-servers-service.ts";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

/**
 * The user's own integrations, filed under the personal realm of settings: they
 * are per-user connections, and the organization-wide Spaces & Integrations page
 * lives under /settings/org. The page came here from /dashboard/integrations,
 * which stays as a redirect.
 *
 * A fresh-mailbox OAuth connect (F3) returns HERE via `/auth/oauth` with the
 * consent `code` and signed `state`; `OutlookConnectActions` (inside the Outlook
 * card) reads them once and completes the grant. Microsoft's registered redirect
 * URI is `/auth/oauth` and is unchanged; only the app-side hop after it moved.
 * An MCP server's sign-in returns here the same way, wherever it started
 * (`McpAuthorizationReturn`).
 */
const integrationsSearchSchema = z.object({
	code: z.string().optional(),
	state: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/settings/integrations")({
	validateSearch: integrationsSearchSchema,
	loader: ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(mcpServersQueryOptions("mine"));
	},
	component: MyIntegrationsPage,
	head: () => ({ meta: [{ title: pageTitle(m.my_integrations_title()) }] }),
});
